<template>
  <div
    class="title"
    :class="{
      'pink-title': pinkTitle,
    }"
  >
    {{ title }}
  </div>
</template>

<script>
export default {
  props: ["title", "pinkTitle"],
};
</script>

<style scoped>
.title {
  color: #090741;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.pink-title {
  color: #e2037e;
  font-weight: 700;
  font-size: 22px;
}
</style>
